<template>
  <Modal
    :open="open"
    title="Contrato de Prestação de Serviço"
    :description="blocking ? 'Para continuar, leia e aceite o contrato abaixo.' : undefined"
    size="xl"
    variant="gray"
    :closable="!blocking"
    :close-on-overlay-click="false"
    :close-on-esc="!blocking"
    @close="emit('close')"
  >
    <div v-if="loading" class="text-sm text-slate-400">Carregando...</div>
    <template v-else-if="contract">
      <p v-if="contract.accepted" class="text-sm text-zinc-500 dark:text-zinc-400">
        Aceito em {{ formatDateTime(contract.accepted_at) }}
      </p>
      <div v-html="renderLegalMarkdown(contract.content)" />
    </template>
    <p v-else class="text-sm text-danger-500">Não foi possível carregar o contrato.</p>

    <template #footer>
      <div v-if="contract && !contract.accepted" class="w-full space-y-3">
        <label class="flex items-start gap-2.5 text-sm text-slate-600 dark:text-zinc-300 cursor-pointer">
          <input type="checkbox" v-model="checked" class="w-4 h-4 mt-0.5 rounded accent-primary-500 shrink-0" />
          <span>Li e aceito o Contrato de Prestação de Serviço.</span>
        </label>
        <p v-if="error" class="text-xs text-danger-500">{{ error }}</p>
        <div class="flex justify-end gap-2">
          <button v-if="!blocking" type="button" class="btn-secondary px-4 py-2 text-sm" @click="emit('close')">Fechar</button>
          <button type="button" class="btn-primary px-4 py-2 text-sm" :disabled="!checked || accepting" @click="doAccept">
            <span v-if="accepting" class="loading-spinner w-3.5 h-3.5 mr-1" />
            Aceitar
          </button>
        </div>
      </div>
      <div v-else-if="!blocking" class="flex justify-end">
        <button type="button" class="btn-secondary px-4 py-2 text-sm" @click="emit('close')">Fechar</button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { ref, watch } from 'vue'
import Modal from '../ui/Modal.vue'
import apiClient from '../../api/client.js'
import { renderLegalMarkdown } from '../../utils/legalMarkdown.js'

const props = defineProps({
  open: { type: Boolean, default: false },
  // Sem botão de fechar/Esc/clique fora — usado no fluxo obrigatório de
  // aceite pós-login (ver App.vue), mesmo espírito do modal de Termos/
  // Privacidade (:closable="false" lá).
  blocking: { type: Boolean, default: false },
})

const emit = defineEmits(['close', 'accepted'])

const contract = ref(null)
const loading = ref(false)
const checked = ref(false)
const accepting = ref(false)
const error = ref('')
const formatDateTime = (iso) => iso ? new Date(iso).toLocaleString('pt-BR') : ''

async function loadContract() {
  loading.value = true
  contract.value = null
  checked.value = false
  error.value = ''
  try {
    const { data } = await apiClient.get('/service-contract/current')
    contract.value = data.data
  } catch {
    contract.value = null
  } finally {
    loading.value = false
  }
}

watch(() => props.open, (isOpen) => {
  if (isOpen) loadContract()
})

async function doAccept() {
  accepting.value = true
  error.value = ''
  try {
    await apiClient.post('/service-contract/accept')
    emit('accepted')
    emit('close')
  } catch (err) {
    error.value = err.response?.data?.error || 'Erro ao registrar aceitação do contrato.'
  } finally {
    accepting.value = false
  }
}
</script>
